import React from 'react'
//import { useRef } from 'react'

export default function Contact() {
   
  return (
    <div className='container' >
     
     <div className="  card-header card text-center">
 
  <div className="my-4 card-body">
  <h2>Feel free to contact us!</h2>
  </div>
    <h1 className='my-2'>
      <a href="https://www.linkedin.com/in/satyam-gupta-a457b4207/" target='blank'> <i className="bi bi-linkedin "></i></a>
    </h1>
    
     <h5 className='my-4'> <i className=" bi bi-envelope-fill "> aus.cse4thsem@gmail.com</i></h5>
    
  
</div>
    </div>
  )
}
